<template>
  <div 
    class="mfw-form-wrapper" 
    :class="$wizardConfig.displayMode === 'fullScreen' ? 'fullscreen' : ''"
  >
      <top-bar />

      <v-tabs-items
        v-model="$formController.currentStep"
      >
        <v-tab-item
          v-for="(step, index) in $formController.steps"
          :key="index"
          class="step-content"
        >
          <component
            :is="step.component"
          ></component>
        </v-tab-item>
      </v-tabs-items>

      <v-progress-linear
        v-if="$wizardConfig.progressBar.position !== 'none'"
        :value="$formController.progress"
        color="primary"
        :bottom="$wizardConfig.progressBar.position === 'bottom'"
        :top="$wizardConfig.progressBar.position === 'top'"
        :style="progressBarStyles"
        class="wizard-progress"
      />

      <recaptcha v-if="$wizardConfig.recaptcha" />

      <tab-navigation
        :steps="$formController.steps"
      ></tab-navigation>
  </div>

</template>

<script>
import Recaptcha from './Recaptcha'
import TabNavigation from './TabNavigation'
import TopBar from './TopBar'

export default {
  components: {
    Recaptcha,
    TopBar,
    // TabNavigation
  },
  data() {
    return {
      progressBarStyles: ''
    }
  },
  methods: {
    calculateProgressBarStyles() {
      if (this.$wizardConfig.progressBar.attach !== undefined) {
        const attachEl = document.getElementById(this.$wizardConfig.progressBar.attach)
        const attachElWidth = attachEl.offsetWidth //Match the width to the attach element
        const attachElLeftPos = attachEl.getBoundingClientRect().left //Align to the attach element
      this.progressBarStyles = 'width: ' + attachElWidth + 'px !important; position: fixed; left: ' + attachElLeftPos + 'px !important;'
      } else {
        this.progressBarStyles = ''
      }
    }
  },
  mounted() {
    this.calculateProgressBarStyles()
    window.addEventListener('resize', () => this.calculateProgressBarStyles())
  }
};
</script>

<style>
.mfw-form-wrapper.fullscreen {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.mfw-form-wrapper .v-tabs {
  flex-grow: 0 !important;
}

.mfw-form-wrapper .v-window {
  display: flex;
  flex-grow: 1;
  align-content: center;
  justify-content: center; 
}
.mfw-form-wrapper.fullscreen .v-window {
  margin-bottom: 48px;
  overflow: auto;
  padding: 12vh 0;
}

.mfw-form-wrapper .v-window__container {
  width: 100%;
}

.step-content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 12px;
}
.mfw-form-wrapper.fullscreen .step-content {
  overflow: auto !important;
  padding-bottom: 20px;
}

.step-icon {
  margin-right: 8px;
  font-size: 21px !important;
}

/* Vuetify overrides ********************************************/

.wizard-progress {
  background: white !important;
}

.wizard-progress.v-progress-linear {
  transition: width none !important;
  height: 6px !important;
  z-index: 3 !important;
}

/* .v-btn.theme--light .v-btn__content {
  opacity: 1;
} */

.theme--light.v-btn.v-btn--disabled .v-btn__loading {
  opacity: 0 !important;
}

/* Transitions **************************************************/
.pop-in-enter,
.pop-in-leave-to {
  opacity: 0;
  transform: scale3d(0, 0, 0) !important;
}
.pop-in-leave,
.pop-in-enter-to {
  opacity: 1;
  transform: scale3d(1, 1, 1) !important;
}
.pop-in-enter-active,
.pop-in-leave-active {
  transition: all 250ms;
}
</style>
